import { HttpClient } from '../shared/http-client';
import 'rxjs/add/operator/map';
var UsuarioService = /** @class */ (function () {
    function UsuarioService(httpClient) {
        this.httpClient = httpClient;
    }
    UsuarioService.prototype.setUsuario = function (usuario) {
        this.usuarioActual = usuario;
    };
    UsuarioService.prototype.getUsuario = function () {
        return this.usuarioActual;
    };
    UsuarioService.prototype.listado = function (pagina, cantidadPorPagina, query) {
        // get users from api
        return this.httpClient.get("/usuarios/?pagina=" + pagina + "&cantidadPorPagina=" + cantidadPorPagina + "&query=" + query)
            .map(function (response) {
            return response.json();
        });
    };
    UsuarioService.prototype.obtenerRoles = function () {
        return this.httpClient.get('/usuarios/roles')
            .map(function (response) {
            return response.json();
        });
    };
    UsuarioService.prototype.guardar = function (usuario) {
        return this.httpClient.post('/usuarios/', usuario);
    };
    UsuarioService.prototype.modificar = function (usuario) {
        return this.httpClient.put('/usuarios/', usuario);
    };
    UsuarioService.prototype.actualizarPassword = function (id, password) {
        return this.httpClient.post('/usuarios/resetPassword', { usuarioId: id, password: password });
    };
    UsuarioService.prototype.eliminar = function (id) {
        return this.httpClient.delete("/usuarios/" + id);
    };
    UsuarioService.prototype.recuperarContraseña = function (username) {
        return this.httpClient.post('/usuarios/password/olvide', { username: username });
    };
    UsuarioService.prototype.modificarPassword = function (usuario) {
        return this.httpClient.post('/usuarios/password/nuevo', usuario);
    };
    UsuarioService.ctorParameters = function () { return [{ type: HttpClient }]; };
    return UsuarioService;
}());
export { UsuarioService };
//# sourceMappingURL=usuario.service.js.map


// WEBPACK FOOTER //
// usuario.service.js